import React from 'react';

import styled from 'styled-components';
import { Checkbox } from 'react-bootstrap';
import cloneDeep from 'lodash/cloneDeep';

const StyledOptionsTitle = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
`;

const StyledBookingOptionItem = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    
    .checkbox {
        margin: 0;
        margin-right: 20px;
        
        input {
            width: 21px;
            height: 21px;
        }
    }
    
    p {
        margin: 0;
        max-width: 50%;
        word-break: break-all;
        margin-right: 30px;
        width: 30%;
    }
    
    div {
        font-weight: 600;
        span {
            display block;
            margin-top: 10px;
            font-weight: 400;
        }
    }
`;

const EventBookableOptions = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  selectedActivity,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  selectedBookingOptions,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onOrderStateChange,
}) => {
  const getOptionSelectedStatus = option => {
    return (
      option &&
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      selectedBookingOptions.find(
        selectedOption => selectedOption.id === option.id
      )
    );
  };

  const onChange = option => {
    let selectedOptionsClone = cloneDeep(selectedBookingOptions);
    const isOptionSelected = getOptionSelectedStatus(option);
    if (getOptionSelectedStatus(isOptionSelected)) {
      selectedOptionsClone = selectedOptionsClone.filter(
        selectedOption => selectedOption.id !== option.id
      );
    } else {
      selectedOptionsClone.push(option);
    }
    onOrderStateChange('selectedBookingOptions', selectedOptionsClone);
  };

  return (
    <>
      <StyledOptionsTitle>Select a package</StyledOptionsTitle>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {selectedActivity.bookingOptions.map(option => (
        <StyledBookingOptionItem key={option.id}>
          <Checkbox
            checked={!!getOptionSelectedStatus(option)}
            onChange={() => onChange(option)}
          />
          <p>{option.title}</p>
          <div>
            ${option.price}
            <span>per {option.pricingModel}</span>
          </div>
        </StyledBookingOptionItem>
      ))}
    </>
  );
};

export default EventBookableOptions;
